/**
 * https://swagger.io/docs/specification/2-0/api-host-and-base-path/
 */
export interface ApiParsedPath {
  /**
   * basePath is the URL prefix for all API paths, relative to the host root. It must start with a leading slash /.
   * If basePath is not specified, it defaults to /, that is, all paths start at the host root.
   *
   * Valid base paths:
   * - `/`
   * - `/v1`
   * - `/v1.0`
   * - `/api/v1`
   * - `/api/v1.0`
   */
  basePath: string;
  path: string;
  pathPrefix?: string;
  version?: string;
  versionMajor?: number;
  versionMinor?: number;
}

export function parseApiPath(path: string): ApiParsedPath {
  if (!path) {
    throw Error('path cannot be empty string');
  }
  if (!path.startsWith('/')) {
    throw Error('Only absolute path can be parsed');
  }

  const parsed = /^((\/api)?(\/v(\d+)(?:\.(\d+))?))?(\/.*)/.exec(path);
  const basePath = parsed?.[1];
  const pathPrefix = parsed?.[2];
  const version = parsed?.[3];
  const versionMajor = parsed?.[4] ? Number.parseInt(parsed[4], 10) : undefined;
  const versionMinor = parsed?.[5] ? Number.parseInt(parsed[5], 10) : undefined;
  const routePath = parsed?.[6];
  return {
    basePath: basePath ?? '/',
    path: routePath ?? '',
    ...(pathPrefix ? { pathPrefix } : {}),
    ...(version ? { version } : {}),
    ...(versionMajor !== undefined ? { versionMajor } : {}),
    ...(versionMinor !== undefined ? { versionMinor } : {}),
  };
}
